// extracted by mini-css-extract-plugin
export default {"ErrorIcon":"ErrorIcon---UxBnd","Subheader":"Subheader---W7G9C"};